import gql from "graphql-tag";

export interface IEmailPreview {
    subject: string;
    body: string;
    errors?: IEmailPreviewError[];
}

export enum EmailPreviewTemplatingErrorType {
    SyntaxError = "SyntaxError",
    UnknownVariable = "UnknownVariable",
    UnknownMemberVariable = "UnknownMemberVariable",
    InaccessibleMemberVariable = "InaccessibleMemberVariable",
}

export interface IEmailPreviewError {
    type: EmailPreviewTemplatingErrorType;
    message: string;
    errorLine: string;
}

export interface IPreviewCommunication {
    previewEmailHtml: IEmailPreview;
}

export interface IEmailPreviewHtml {
    communication: IPreviewCommunication;
}

export const previewEmailQuery = gql`
    query GetEmailPreviewHtml($id: ID!, $context: DynamicTextContextEnum!, $emailDetails: AdvancedEmailPreviewInput!, $participantID: ID) {
        communication {
            previewEmailHtml(id: $id, context: $context, emailDetails: $emailDetails, participantID: $participantID) {
                body
                subject
                errors {
                    type
                    message
                    errorLine
                }
            }
        }
    }
`;
